import { ModelEntityType } from '@upright/common/model/input/types';
import { getEntityType } from '@upright/common/utils';
import { AggregateMetricProps } from '@upright/ui/common/upright/model/output/scores/aggregate-metrics';
import { useParams } from 'react-router-dom';
import { AggregateMetricSelector } from './aggregate-metric-selector';

type Props = {
  valueSetName: string;
} & AggregateMetricProps;

export const AggregateMetricInfo = (props: Props) => {
  const entityId = useParams().id;
  const entityType = entityId ? getEntityType(entityId) : ModelEntityType.COMPANY;

  return (
    <AggregateMetricSelector
      currentMetric={props.currentMetric}
      setAggregateMetric={props.setAggregateMetric}
      availableMetrics={props.availableMetrics}
      entityType={entityType}
    />
  );
};
